import { closeDialog as closeDialogAction, updateDialog as updateDialogAction } from '@Containers/Dialogs/DialogsActions';
import { typeOfHeatmapCellDetailsDialog } from './constants';

export const openDialog =
  ({ matrixName, params, cellData, axisDescription }) =>
  (dispatch) => {
    dispatch(
      updateDialogAction({
        id: typeOfHeatmapCellDetailsDialog,
        dialogType: typeOfHeatmapCellDetailsDialog,
        matrixName,
        params,
        cellData,
        axisDescription,
      })
    );
  };

export const closeDialog = () => (dispatch) => {
  dispatch(
    closeDialogAction({
      id: typeOfHeatmapCellDetailsDialog,
    })
  );
};
